// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import ResizeSvg from '@rsuite/icon-font/lib/layout/Resize';
var Resize = createSvgIcon({
  as: ResizeSvg,
  ariaLabel: 'resize',
  category: 'layout',
  displayName: 'Resize'
});
export default Resize;